import type { Translator } from "./i18n";

export function mailErrorText(
  code: string,
  t: Translator,
  smtpCode = 0,
): string | undefined {
  const messages: Record<string, [string, string]> = {
    SMTP_AUTH_CONNECTION_LOST: [
      "SMTP 认证阶段连接中断，邮件正文尚未提交，请检查客户端访问权限与服务端策略。",
      "The SMTP connection closed during authentication, before message submission. Check client access and server policies.",
    ],
    SMTP_AUTH_TIMEOUT: [
      "SMTP 认证阶段超时，邮件正文尚未提交。",
      "SMTP authentication timed out before message submission.",
    ],
    SMTP_CONNECT_TIMEOUT: [
      "连接 SMTP 服务器超时，邮件正文尚未提交。",
      "Connecting to SMTP timed out before message submission.",
    ],
    SMTP_AUTH_FAILED: [
      "SMTP 认证失败，请检查账号、客户端授权密码及 SMTP 访问权限。",
      "SMTP authentication failed. Check the account, client authorization password, and SMTP access permissions.",
    ],
    SMTP_CERTIFICATE_FAILED: [
      "SMTP 证书验证失败，请检查服务器地址及证书信任配置。",
      "SMTP certificate verification failed. Check the server address and certificate trust.",
    ],
    SMTP_TLS_FAILED: [
      "SMTP TLS 握手失败，请检查端口与连接安全设置。",
      "SMTP TLS handshake failed. Check the port and connection security settings.",
    ],
    SMTP_DNS_FAILED: [
      "无法解析 SMTP 服务器地址，请检查主机名和 DNS。",
      "SMTP hostname resolution failed. Check the hostname and DNS.",
    ],
    SMTP_TIMEOUT: [
      "SMTP 操作超时，投递结果可能未确认，请先检查收件箱和服务端状态。",
      "SMTP timed out; delivery may be uncertain. Check the inbox and server status before retrying.",
    ],
    SMTP_RECIPIENT_REJECTED: [
      "SMTP 服务器拒绝收件地址，请核对收件人及投递权限。",
      "The SMTP server rejected the recipient. Check the address and delivery permissions.",
    ],
    SMTP_SENDER_REJECTED: [
      "SMTP 服务器拒绝发件地址，请核对发件人及发信权限。",
      "The SMTP server rejected the sender. Check the address and sending permissions.",
    ],
    SMTP_MESSAGE_REJECTED: [
      "SMTP 服务器拒绝邮件内容，请检查服务端发送策略。",
      "The SMTP server rejected the message. Check server sending policies.",
    ],
    SMTP_FEATURE_UNSUPPORTED: [
      "SMTP 服务器不支持所需的认证或加密方式。",
      "The SMTP server does not support the required authentication or encryption method.",
    ],
    SMTP_DISCONNECTED: [
      "SMTP 连接中断，投递结果可能未确认，请先检查收件箱。",
      "SMTP disconnected; delivery may be uncertain. Check the inbox before retrying.",
    ],
    SMTP_CONNECT_FAILED: [
      "无法连接 SMTP 服务器，请检查地址、端口和网络。",
      "Cannot connect to SMTP. Check the address, port, and network.",
    ],
    SMTP_PROTOCOL_REJECTED: [
      "SMTP 服务器拒绝协议操作，请检查返回码及服务端策略。",
      "The SMTP server rejected a protocol operation. Check the reply code and server policies.",
    ],
    SMTP_DELIVERY_FAILED: [
      "邮件发送失败，未获得更具体的错误分类。",
      "Email sending failed; a more specific failure category is unavailable.",
    ],
  };
  const message = messages[code];
  if (!message) return undefined;
  return (
    t(message[0], message[1]) +
    (smtpCode >= 100 && smtpCode <= 599 ? ` (SMTP ${smtpCode})` : "")
  );
}
